import React from 'react';

import { useGraphQLQuery } from '@betterment/graphql';
import { Card, Heading, Separator } from '@betterment/samba-react';
import { CardLoader, ErrorBoundary } from '@betterment/shared-components';

import { PerformanceArticlesDocument } from './graphql/performanceArticles.generated';

import { Article } from '../../../../Shared/components-v2/article/Article';

const MAX_ARTICLES_TO_DISPLAY = 4;

const ArticlesCardView: React.FC = () => {
  const { data } = useGraphQLQuery(PerformanceArticlesDocument, { throwOnError: true });

  if (!data) return <CardLoader />;

  if (!data.articles.length) return null;

  const articlesToDisplay = data.articles.slice(0, MAX_ARTICLES_TO_DISPLAY);

  return (
    <Card>
      <Card.Header css={{ padding: 'space.300' }}>
        <Heading as="h2" variant="title200">
          Explore more
        </Heading>
      </Card.Header>
      <Separator css={{ fullWidthWithInset: 'space.300' }} />
      <Card.Content
        css={{
          padding: 'space.300',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(30rem, 1fr))',
          gap: ['space.200', 'space.300'],
        }}
      >
        {articlesToDisplay.map(article => (
          <Article {...article} key={article.id} />
        ))}
      </Card.Content>
    </Card>
  );
};

export const ArticlesCard: React.FC = () => (
  <ErrorBoundary fallbackType="none">
    <ArticlesCardView />
  </ErrorBoundary>
);
